import React from "react";
import { Switch } from "react-router-dom";
import { Image, Grid } from "semantic-ui-react";

import PromotionCarousel from "./components/carousel/PromotionCarousel";
import LoginPage from "./components/pages/LoginPage";
import PreSignupPage from "./components/pages/PreSignupPage";
import SignupPage from "./components/pages/SignupPage";
import SignupCompletedPage from "./components/pages/SignupCompletedPage";
import DashBoardPage from "./components/pages/DashBoardPage";
import ResetPasswordPage from "./components/pages/ResetPasswordPage";
import ForgotPasswordPage from "./components/pages/ForgotPasswordPage";
import UserRoute from "./components/routes/UserRoute";
import GuestRoute from "./components/routes/GuestRoute";

// import logo from "./assets/images/logo_auna.svg";
import logo from "./assets/images/laboratorio.png";
import "semantic-ui-css/semantic.min.css";
// import './skeleton.css';

const App = ({ location }) => {
  return (
    <Grid style={{ marginLeft: "0rem", marginRight: "0rem" }}>
      <Grid.Row
        verticalAlign="middle"
        centered
        style={{ paddingBottom: "0px", backgroundColor: "#FFFFFF" }}
        className="Banner notPrintable"
      >
        <Grid.Column mobile={12} tablet={4} computer={3}>
          <a href="/">
            <Image id="svgImg" className="mobileLogo" src={logo} />
          </a>
        </Grid.Column>
        <Grid.Column
          id="Carousel"
          only="tablet computer"
          tablet={12}
          computer={13}
          style={{ paddingLeft: "0em", paddingRight: "0em" }}
        >
          <PromotionCarousel />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row verticalAlign="middle" centered>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <Switch>
            <GuestRoute
              location={location}
              path="/presignup"
              exact
              component={PreSignupPage}
            />
            <GuestRoute
              location={location}
              path="/signup"
              exact
              component={SignupPage}
              value="practitioner"
            />
            <GuestRoute
              location={location}
              path="/forgot_password"
              exact
              component={ForgotPasswordPage}
            />
            <GuestRoute
              location={location}
              path="/reset_password/:token"
              exact
              component={ResetPasswordPage}
            />
            <UserRoute
              location={location}
              path="/signupCompleted"
              exact
              component={SignupCompletedPage}
            />
            <UserRoute
              location={location}
              path="/"
              exact
              component={DashBoardPage}
            />
            <GuestRoute location={location} component={LoginPage} />
          </Switch>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default App;
